module.exports = __webpack_public_path__ + "static/media/registration.styles.47d4ff7a.less";